export default {
  computed: {
    hasQueryEvents() {
      return this.queryParam.events.length > 0;
    },
    hasQueryCategory() {
      return this.queryParam.categorys.length > 0;
    }
  },
  methods: {
    filterHasItem(id, type = this.type) {
      //判断分类或者事件是否存在
      if (type === "category") {
        return Boolean(this.categorys[id]);
      } else {
        return Boolean(this.events[id]);
      }
    },
    filterCategoryTest(id) {
      if (!this.filterHasItem(id, "category")) return false;
      const filter = this.filterOption.categoryType;
      const inQueryList = this.queryParam.categorys.includes(
        this.categorys[id].name
      );
      switch (filter) {
        case "allow":
          return inQueryList;
        case "exclude":
          return !inQueryList;
      }
    },

    filterEventTest(id) {
      if (!this.filterHasItem(id, "event")) return false;
      const filter = this.filterOption.eventType;
      const inQueryList = this.queryParam.events.includes(this.events[id].name);
      switch (filter) {
        case "allow":
          return inQueryList;
        case "exclude":
          return !inQueryList;
      }
    },

    filterOperationTest(testCategoryResult, testEventResult) {
      if (!this.hasQueryCategory) return testEventResult;
      if (!this.hasQueryEvents) return testCategoryResult;

      const operation = this.filterOption.operation;
      switch (operation) {
        case "intersection":
          return testCategoryResult && testEventResult;
        case "union":
          return testCategoryResult || testEventResult;
      }
    },

    filterRecordTest(record) {
      //1. 判断是否存在该事件或分类
      if (!this.filterHasItem(record[this.type])) return false;

      //2. 判断是否有查询
      if (!this.hasQueryEvents && !this.hasQueryCategory) return true;

      //3. 测试分类
      const testCategory = this.filterCategoryTest(record.category);

      //4. 测试时间
      const testEvent = this.filterEventTest(record.event);

      //5. 测试集合操作
      return this.filterOperationTest(testCategory, testEvent);
    }
  }
};
